import EditOrder from './EditOrder.vue';

export default EditOrder;
